import { ActionSettings, GetTableDataSettings } from '@fl/cmsch-fe-library';
import React, { Fragment, FC, memo, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Api } from 'api/gen/Api';
import { UserView } from 'api/gen/UserView';
import * as routerActions from 'app/router';
import { simpleUserSelector } from 'app/user/model/selector';
import { ConnectedTable } from 'utils/tables';
import { usersColumns } from './columns';
import { rowMapper } from './row-mapper';
import { adminUserPathNameForRefresh } from '../../constants/consts';
import { adminPermissions } from '../../constants/permissions';
import { adminAction } from '../../model';
import { simpleAdminSelector } from '../../model/selector';
import { UsersTableType } from '../../types/users-table-type';
const getUsersDataSettings: GetTableDataSettings<UserView, UserView> = {
  apiRequest: Api.getUsersPage,
  successAction: adminAction.getUsersSuccess
};
const UsersTableBase: FC = _ => {
  const dispatch = useDispatch();
  const userPermissions = useSelector(simpleUserSelector.currentUserPermissions);
  const handleShowDetail = useCallback((rowId: number) => {
    dispatch(routerActions.push(`/administrace/uzivatele/${rowId}`));
  }, [dispatch]);
  const actionSettings: ActionSettings<UsersTableType> = useMemo(() => ({
    extraActions: [{
      id: 'detail',
      callback: handleShowDetail,
      hidden: !userPermissions.includes(adminPermissions.users),
      icon: 'searchOutlined'
    }]
  }), [handleShowDetail, userPermissions]);
  return <Fragment>
            <ConnectedTable tableId="users" columns={usersColumns} getTableDataSettings={getUsersDataSettings} rowDataToTableRowMapper={rowMapper} rowDataPageSelector={simpleAdminSelector.usersPage} actionSettings={actionSettings} showFulltextFilter enableTableSettings enableTableUserSettings paginationPosition="both" highlightOnEdit pathnamesForRefresh={adminUserPathNameForRefresh} data-sentry-element="ConnectedTable" data-sentry-source-file="index.tsx" />
        </Fragment>;
};

/**
 * Admin users table.
 *
 * @returns Users table component.
 */
export const UsersTable = memo(UsersTableBase);